try {
  const selectEls = document.querySelectorAll("select");
  const hintEls = Array.from(document.querySelectorAll("[data-form-select-hint]"));

  const updateHintsVisibility = (value) => {
    const activeHintEls = hintEls.filter(
      (hintEl) =>
        hintEl.getAttribute("data-form-select-hint") === value && hintEl.innerText.trim() !== "",
    );

    hintEls.forEach((hintEl) => {
      hintEl.style.display = activeHintEls.includes(hintEl) ? "block" : "none";
    });
  };

  selectEls.forEach((selectEl) => {
    updateHintsVisibility(selectEl.value);

    selectEl.addEventListener("change", (e) => {
      updateHintsVisibility(e.target.value);
    });
  });
} catch (error) {
  console.error("Error handling hint visibility:", error);
}
